var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7867 1.93334L28.4533 7.26667C28.8976 7.48744 29.2715 7.82777 29.533 8.2494C29.7944 8.67102 29.9331 9.15723 29.9333 9.65334V22.36C29.9331 22.8561 29.7944 23.3423 29.533 23.7639C29.2715 24.1856 28.8976 24.5259 28.4533 24.7467L17.7867 30.08C17.4162 30.2654 17.0076 30.3619 16.5933 30.3619C16.1791 30.3619 15.7705 30.2654 15.4 30.08L4.73333 24.7467C4.2895 24.523 3.917 24.1798 3.65785 23.7558C3.3987 23.3317 3.26321 22.8436 3.26667 22.3467V9.65334C3.26693 9.15723 3.40558 8.67102 3.66704 8.2494C3.92849 7.82777 4.30238 7.48744 4.74667 7.26667L15.4133 1.93334C15.7821 1.75011 16.1882 1.65475 16.6 1.65475C17.0118 1.65475 17.4179 1.75011 17.7867 1.93334V1.93334Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69334 8.21333L16.6 14.6667L29.5067 8.21333",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 30.3467V14.6667",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.8118af03eeb05331a6fc841a97d5fce7.svg";
export { ForwardRef as ReactComponent };